exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".provider-panel--fQzgPgwua_7efONokVVsx {\n  display: flex;\n  align-items: center;\n  column-gap: .25rem;\n  font-weight: 500;\n}\n\n.provider-panel--fQzgPgwua_7efONokVVsx .provider-panel--3dSjxZUXW8AXE9d85Bnk0s {\n  color: #265b91;\n}\n\n.provider-panel--fQzgPgwua_7efONokVVsx .provider-panel--3dSjxZUXW8AXE9d85Bnk0s [data-testid=\"link\"] {\n  font-weight: 500;\n}\n", ""]);

// exports
exports.locals = {
	"activePatientsLimit": "provider-panel--fQzgPgwua_7efONokVVsx",
	"activePatientsLimit": "provider-panel--fQzgPgwua_7efONokVVsx",
	"linkWrapper": "provider-panel--3dSjxZUXW8AXE9d85Bnk0s",
	"linkWrapper": "provider-panel--3dSjxZUXW8AXE9d85Bnk0s"
};